import { Component } from 'react';
import { observer } from 'mobx-react';
import propTypes from 'prop-types';

import { EditNameField } from './EditNameField.jsx';
import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

class _EditableLabel extends Component {
  handleEditStart = () => {
    this.props.item.changeEditMode(true);
  };

  render() {
    const { item } = this.props;

    return (
      item.isEditMode
        ? <EditNameField item={item} />
        : (
          <>
            <h2 className="cart-group__title">{item.name}</h2>
            <button
              type="button"
              className="button-less cart-group__icon cart-group__icon--base pencil-icon"
              onClick={this.handleEditStart}
            >
              <PesIcon class="cart-group__icon-svg" size={pesIconSizes.SMALL}>
                action_editor
              </PesIcon>
            </button>
          </>
        )
    );
  }
}

_EditableLabel.propTypes = {
  item: propTypes.shape({
    name: propTypes.string,
    changeEditMode: propTypes.func,
    isEditMode: propTypes.bool
  }).isRequired

};

export const EditableLabel = observer(_EditableLabel);
